import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { asyncScheduler, forkJoin, Observable, of, scheduled } from 'rxjs';
import { DeliveryDefenseService } from '../services/delivery-defense.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { catchError, concatAll, finalize } from 'rxjs/operators';
import { AuthenticationService } from '../../core/services/authentication/authentication.service';
import { Feature } from '../../shared/models/feature.enum';
import { IProductAgreement } from '../../shared/models/product-agreement.interface';

@Component({
    selector: 'upsc-dd-agreement-beta-dialog',
    templateUrl: './dd-agreement-beta-dialog.component.html',
    styleUrls: ['./dd-agreement-beta-dialog.component.scss'],
})
export class DDAgreementBetaDialogComponent {
    @HostBinding('class') public hostClass = 'dd-agreement-beta-dialog';

    public isAcceptingAgreement = false;
    public isDecliningAgreement = false;
    public agreement$: Observable<IProductAgreement | string>;
    public formGroup: UntypedFormGroup;

    constructor(public dialogRef: MatDialogRef<DDAgreementBetaDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private readonly formBuilder: UntypedFormBuilder,
                private readonly deliveryDefenseService: DeliveryDefenseService,
                private readonly authService: AuthenticationService,
    ) {
        this.formGroup = this.formBuilder.group({
            isAgreed: [false, Validators.requiredTrue],
        });

        this.agreement$ = scheduled(
            [
                of(null),
                this.deliveryDefenseService.getAgreementBeta(Feature.DeliveryDefense),
            ],
            asyncScheduler)
            .pipe(
                concatAll(),
                catchError(() => of('error')),
            );
    }

    public async accept(event: MouseEvent): Promise<void> {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.isAcceptingAgreement = true;
        await this.deliveryDefenseService.acceptAgreementBeta(Feature.DeliveryDefense).toPromise();
        this.isAcceptingAgreement = false;

        this.dialogRef.close();
    }

    public async decline(event: MouseEvent): Promise<void> {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.isDecliningAgreement = true;
        forkJoin([
            // this.deliveryDefenseService.declineAgreementBeta(),
            // this.deliveryDefenseService.turnOffDeliveryDefense(),
            of(true),
        ])
            .pipe(
                finalize(() => {
                    this.isDecliningAgreement = false;
                    this.dialogRef.close();
                }),
            )
            .subscribe(async () => {
                await this.authService.logout();
            });
    }
}
